<template>
  <div class="home">
    <Header header="landing-page"/>
    <b-container class="content-narrow py-5">
      <p class="font-black">{{ getContent }}</p>
      <Wave />
      <router-link :to="{ name: 'rules'}"><p class="mt-3">{{ $t('general.policy' )}}</p></router-link>
    </b-container>
    <div id="map">
      <b-img class="d-md-none" fluid-grow :src="require('../assets/images/unelmakone-karta-' + language  + '-mobile.jpg')"></b-img>
      <b-img class="d-none d-md-block" fluid-grow :src="require('../assets/images/unelmakone-karta-' + language  + '.jpg')"></b-img>
      <div class="decobar decobar-green"></div>
    </div>
    <b-container>
      <Realtors />
    </b-container>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer'
import Wave from '@/assets/svg/wave.svg'
import Realtors from '@/components/Realtors'

export default {
  name: 'Home',
  data () {
    return {
      content: this.$store.state.language
    }
  },
  components: { Realtors, Footer, Header, Wave },
  computed: {
    getContent () {
      return this.$store.getters.getPage('landing-page').content
    },
    language () {
      return this.$store.state.language
    }
  },
  methods: {
  }
}
</script>
